import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GalleryViewPage } from './gallery-view.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'galleries/:id',
    component: GalleryViewPage,
    canActivate: [authGuard, hasRoleGuard(null, ['update_galleries'])]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GalleryViewPageRoutingModule { }
